import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromWeatherEarthquake from './state/weather-earthquake.reducer';
import { WeatherEarthquakeEffects } from './state/weather-earthquake.effects';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(fromWeatherEarthquake.FEATURE_KEY, fromWeatherEarthquake.reducer),
        EffectsModule.forFeature([WeatherEarthquakeEffects]),
    ],
})
export class WeatherEarthquakeDataAccessModule {}
